<!-- Ported from the Polaris kit: src/components/ui/range-calendar/RangeCalendarNextButton.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { ChevronRight16 as ChevronRight } from '@carbon/icons-vue';
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarNext, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../button';

const props = defineProps({
  nextPage: { type: Function, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarNext
    data-slot="range-calendar-next-button"
    :class="
      cn(
        buttonVariants({ variant: 'outline' }),
        'absolute right-1',
        'size-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot>
      <ChevronRight class="size-4 p-0" />
    </slot>
  </RangeCalendarNext>
</template>
